import React from 'react';

const SkeletonLoader = ({ className = '', variant = 'default' }) => {
  const baseClasses = 'animate-pulse bg-muted rounded-md';
  
  const variants = {
    default: 'h-4 w-full',
    text: 'h-4 w-3/4',
    title: 'h-6 w-1/2',
    circle: 'rounded-full',
    card: 'h-48 w-full',
    thumbnail: 'aspect-[3/4] w-full',
    page: 'aspect-[3/4] w-full',
    button: 'h-10 w-24'
  };

  return (<div className={`${baseClasses} ${variants?.[variant] || variants?.default} ${className}`} />);
};

export default SkeletonLoader;